import { RETURN_HISTORY,
    RETURN_HISTORY_SUCCESS,
    RETURN_HISTORY_FAIL,
    GET_DRIVER_APP_RETURN_LIST,
    GET_DRIVER_APP_RETURN_LIST_SUCCESS,
    GET_DRIVER_APP_RETURN_LIST_FAIL,
    SELF_RETURN_MANUAL,
    SELF_RETURN_MANUAL_SUCCESS,
    SELF_RETURN_MANUAL_FAIL,
    GET_NEW_STORAGE_INFO,
    GET_NEW_STORAGE_INFO_SUCCESS,
    GET_NEW_STORAGE_INFO_FAIL } from '../actions/types';

const initialState = {
    returnHistory: [],
    returnHistoryLoading: false,
    returnHistoryError: false,
    driverAppReturnList: [],
    getDriverAppReturnListLoading: false,
    driverAppReturnListError: false,
    selfReturnManual: [],
    selfReturnManualLoading: false,
    selfReturnManualError: false,
    newStorageInfo: [],
    getNewStorageInfoLoading: false,
    newStorageInfoError: false
}

export default function srReducer(state = initialState, action){
    switch(action.type){
        case RETURN_HISTORY:
            return {
                ...state,
                returnHistoryLoading: true,
            }
        case RETURN_HISTORY_SUCCESS:
            return {
                ...state,
                returnHistory: action.payload,
                returnHistoryLoading: false
            }
        case RETURN_HISTORY_FAIL:
            return {
                ...state,
                returnHistoryLoading: false,
                returnHistoryError: action.payload
            }
        case GET_DRIVER_APP_RETURN_LIST:
            return {
                ...state,
                getDriverAppReturnListLoading: true,
            }
        case GET_DRIVER_APP_RETURN_LIST_SUCCESS:
            return {
                ...state,
                driverAppReturnList: action.payload,
                getDriverAppReturnListLoading: false
            }
        case GET_DRIVER_APP_RETURN_LIST_FAIL:
            return {
                ...state,
                getDriverAppReturnListLoading: false,
                driverAppReturnListError: action.payload
            }
        case SELF_RETURN_MANUAL:
            return {
                ...state,
                selfReturnManualLoading: true
            }
        case SELF_RETURN_MANUAL_SUCCESS:
            return {
                ...state,
                selfReturnManual: action.payload,
                selfReturnManualLoading: false
            }
        case SELF_RETURN_MANUAL_FAIL:
            return {
                ...state,
                selfReturnManualLoading: false,
                selfReturnManualError: action.payload
            }
        case GET_NEW_STORAGE_INFO:
            return {
                ...state,
                getNewStorageInfoLoading: true
            }
        case GET_NEW_STORAGE_INFO_SUCCESS:
            return {
                ...state,
                getNewStorageInfoLoading: false,
                newStorageInfo: action.payload
            }
        case GET_NEW_STORAGE_INFO_FAIL:
            return {
                ...state,
                getNewStorageInfoLoading: false,
                newStorageInfoError: action.payload
            }
        default:
            return state;
    }
}